import React, { Component } from "react";
import { Divider, Modal, Button, Table } from "antd";
import Echarts from "nbugs-echarts";
import moment from "moment";
import { connect } from "dva";
import Container from "@/components/Container";
import styles from "./index.less";
import findImg from "../assets/find.svg";
import totalImg from "../assets/total.svg";
import handleImg from "../assets/handle.svg";
import finishImg from "../assets/finish.svg";

@connect(({ dangerAnalysis, user }) => ({
  ...dangerAnalysis,
  currentUser: user.currentUser
}))
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowTypeModal: false
    };
  }

  componentDidMount() {
    this.handleGetAnalysisData();
    this.handleGetTypeData();
    this.handleGetDistributionData();
  }

  // 获取隐患数据分析
  handleGetAnalysisData = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "dangerAnalysis/fetchAnalysisData"
    });
  };

  // 获取隐患类别
  handleGetTypeData = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "dangerAnalysis/fetchDangerType"
    });
  };

  // 获取隐患分布
  handleGetDistributionData = () => {
    const { dispatch } = this.props;
    dispatch({
      type: "dangerAnalysis/fetchDistribution"
    });
  };

  // 展示弹框
  handleShowModal = () => {
    this.setState({
      isShowTypeModal: true
    });
  };

  // 关闭弹框
  handleCloseModal = () => {
    this.setState({
      isShowTypeModal: false
    });
  };

  // 渲染隐患状态的饼图
  renderDangerStatus = () => {
    const { analysisData } = this.props;
    const { complete, handle } = analysisData;
    const dangerStatusProps = {
      type: "pie",
      echartsId: "dangerStatusContainer",
      typeProps: {
        width: "100%",
        height: "100%"
      },
      dataSource: [
        {
          name: "已完成",
          value: complete || 0
        },
        {
          name: "处理中",
          value: handle || 0
        }
      ]
    };

    return (
      <div className="itemEchartsContainer">
        <div className="title">隐患状态</div>
        <div
          id="dangerStatusContainer"
          style={{ width: "100%", height: 400 }}
        />
        <Echarts {...dangerStatusProps} />
      </div>
    );
  };

  // 渲染隐患级别的饼图
  renderDangerLevel = () => {
    const { levelData } = this.props;
    const tempDataSource = [];
    levelData.forEach(item => {
      tempDataSource.push({ name: item.hidden, value: item.number || 0 });
    });

    const dangerLevelProps = {
      type: "pie",
      echartsId: "dangerLevelContainer",
      typeProps: {
        width: "100%",
        height: "100%"
      },
      dataSource: tempDataSource
    };
    return (
      <div className="itemEchartsContainer">
        <div className="title">隐患级别</div>
        <div id="dangerLevelContainer" style={{ width: "100%", height: 400 }} />
        <Echarts {...dangerLevelProps} />
      </div>
    );
  };

  // 渲染隐患类别的柱状图
  renderDangerType = () => {
    const { typeData } = this.props;
    const tempDataSource = [];
    typeData.forEach(item => {
      tempDataSource.push([item.number || 0, item.hidden]);
    });

    const dangerLevelProps = {
      type: "bar",
      echartsId: "dangerTypeContainer",
      dataSource: tempDataSource,
      axisProps: {
        type: "y"
      }
    };
    return (
      <div className="itemEchartsContainer">
        <div className="title">
          隐患类别
          {tempDataSource && tempDataSource.length > 10 && (
            <span className="viewAll" onClick={this.handleShowModal}>
              查看全部
            </span>
          )}
        </div>
        <div id="dangerTypeContainer" style={{ width: "100%", height: 400 }} />
        <Echarts {...dangerLevelProps} />
      </div>
    );
  };

  // 渲染隐患分布的雷达图
  renderDangerDistribution = () => {
    const { distributionData } = this.props;
    const tempIndicatorData = [];
    const tempValue = [];
    distributionData.forEach(item => {
      tempIndicatorData.push({ name: item.dicName, max: 150 });
      tempValue.push(item.sumNumber);
    });
    const dangerDistributionProps = {
      type: "radar",
      echartsId: "dangerDistributionContainer",
      indicatorData: tempIndicatorData,
      dataSource: [{ value: tempValue }]
    };
    return (
      <div className="itemEchartsContainer">
        <div className="title">隐患分布</div>
        <div
          id="dangerDistributionContainer"
          style={{ width: "100%", height: 400, marginTop:40 }}
        />
        {tempValue.length > 0 ? <Echarts {...dangerDistributionProps} /> : null}
      </div>
    );
  };

  // 隐患类别的弹窗
  renderTypeModal = () => {
    const { isShowTypeModal } = this.state;
    const { typeData } = this.props;
    const typeModalProps = {
      title: "全部详情",
      visible: isShowTypeModal,
      onCancel: this.handleCloseModal,
      footer: (
        <Button type="primary" onClick={this.handleCloseModal}>
          确定
        </Button>
      )
    };
    const tableProps = {
      columns: [
        {
          title: "名称",
          dataIndex: "hidden",
          key: "hidden"
        },
        {
          title: "数据",
          dataIndex: "number",
          key: "number"
        }
      ],
      dataSource: typeData,
      pagination: false
    };
    return (
      <Modal {...typeModalProps}>
        <Table {...tableProps} />
      </Modal>
    );
  };

  render() {
    const { analysisData, currentUser } = this.props;
    const { enOrgType } = currentUser;
    const { complete, handle, sumNumber, today, gmtModify } = analysisData;
    const searchType = enOrgType === "general_school" ? "school" : "bureau";
    const totalData = [
      {
        title: "隐患总量",
        icon: totalImg,
        number: sumNumber || "-"
      },
      {
        title: "今日发现",
        icon: findImg,
        number: today || "-"
      },
      {
        title: "处理中",
        icon: handleImg,
        number: handle || "-"
      },
      {
        title: "已完成",
        icon: finishImg,
        number: complete || "-"
      }
    ];
    return (
      <Container breStates={1}>
        <div className={styles.root}>
          <div className="headContainer">
            <div className="title">安全隐患数据分析</div>
            <div className="updateTime">
              最后更新时间：
              {gmtModify ? moment(gmtModify).format("llll:s") : "-"}
            </div>
          </div>
          <div className="dataContainer">
            {totalData.map(item => {
              return (
                <div className="ItemDataContainer">
                  <div className="iconContainer" style={item.style}>
                    <img src={item.icon} alt="" />
                  </div>
                  <div className="detailContainer">
                    <p>{item.number}</p>
                    <p>{item.title}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <Divider dashed />
          <div className="echartsContainer">
            {this.renderDangerStatus()}
            {this.renderDangerLevel()}
            {this.renderDangerType()}
            {searchType === "bureau" && this.renderDangerDistribution()}
          </div>
        </div>
        {this.renderTypeModal()}
      </Container>
    );
  }
}

export default index;
